import React, { FunctionComponent, ReactElement } from "react";
import { GridCell, GridRow } from "@episerver/ui-framework";
import "./grid.scss";

export const Column: FunctionComponent = ({ children, ...props }) => {
    return (
        <GridCell className="column" {...props}>{children}</GridCell >
    );
};

interface RowProps {
    /** Column components */
    children: ReactElement | ReactElement[];
}

export const Row: FunctionComponent<RowProps> = ({
    children
}: RowProps) => {
    // Probably just one column. The Row/Columns component don't need to be used for this case.
    if (!Array.isArray(children)) {
        // When not in production, the elements has a `_source` property that's useful for outputting what file is causing this.
        const source: any = (children as any)._source;
        // The _source.lineNumber would be useful to include but it tends to show a line much after the faulty line.
        const hint = source && `See file ${source.fileName}`;

        console.warn("Using <Row> and <Column> for a single column layout is not necessary.", hint, children); // eslint-disable-line no-console
        return (
            <GridRow>{children}</GridRow>
        );
    }

    // Render columns as expected. Resize the width (span prop) by counting the columns.
    return (
        <GridRow>
            {children.map((child, index) =>
                React.cloneElement(child, {
                    span: 12 / children.length,
                    key: index
                }))
            }
        </GridRow>
    );
};
